import { laptopLargeMax, mobileXXLargeMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import bg from '@propertypal/shared/src/resources/bg/ea-websites-header.jpg';
import platform from '@propertypal/shared/src/utils/platform';
import { Container as Button } from '@propertypal/web-ui/src/buttons/Button.style';
import ProductsTabs from '@propertypal/web-ui/src/tabs/ProductsTabs';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 1280px;
  padding: 0 30px;

  @media (${tabletMax}) {
    padding: 0 20px;
  }
`;

export const HeaderBox = styled.div<{ hero: string }>`
  position: relative;
  background-color: ${({ theme }) => theme.black};
  background-image: url(${({ hero }) => (hero || bg).src});
  background-size: cover;
  background-position: 50% 35%;
  width: 100%;
  height: 780px;
  padding: 200px 0;

  @media (${laptopLargeMax}) {
    background-position: center;
  }

  @media (${tabletMax}) {
    background-position: right -280px center;
    background-size: auto 110%;
    height: 500px;
    padding: 120px 0 50px 0;
  }

  @media (${mobileXXLargeMax}) {
    background-size: auto 100%;
  }
`;

export const HeaderTextBox = styled.div<{ subHeadingMaxW?: number }>`
  width: 100%;
  max-width: 400px;

  h1 {
    font-family: ${platform.headingFont};
    font-size: 60px;
    color: ${(props) => props.theme.white};
    line-height: 1;
    margin-bottom: 25px;
  }

  h2 {
    color: ${(props) => props.theme.white};
    font-size: 28px;
    font-weight: 600;
    line-height: 1.29;
    margin-bottom: 45px;
    ${({ subHeadingMaxW }) =>
      subHeadingMaxW
        ? css`
            max-width: ${subHeadingMaxW}px;
          `
        : ''}
  }

  ${Button} {
    max-width: 300px;
  }

  @media (${tabletMax}) {
    max-width: 300px;

    h1 {
      font-size: 40px;
      margin-bottom: 15px;
    }

    h2 {
      font-size: 18px;
      width: 240px;
      margin-bottom: 15px;
    }

    ${Button} {
      max-width: 240px;
    }
  }
`;

export const GradientBgAngle = styled.div<{ color: string; reverse?: boolean }>`
  width: 100%;
  position: absolute;
  height: 100px;
  overflow: hidden;
  bottom: -1px;

  &::before {
    content: ' ';
    display: block;
    ${({ reverse }) =>
      reverse
        ? css`
            border-right: 0 solid transparent;
            border-left: 100vw solid transparent;
          `
        : css`
            border-left: 0 solid transparent;
            border-right: 100vw solid transparent;
          `}

    border-bottom: 100px solid ${(props) => props.color};
  }
`;

export const Tabs = styled(ProductsTabs)`
  position: absolute;
  top: 40px;
  left: 0;
  right: 0;
  max-width: fit-content;
  margin: 0 auto;
`;
